import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import CountUp from "react-countup";
import { Message, MessageBox } from "element-react";
import PageTitle from "../../../commons/components/PageTitle";
import {
  InfoArea,
  InfoHead,
  InfoContent,
  InfoList,
  ListWrapper,
  InfoListBox,
} from "../PlantListStyle";
import PS from "./../MonitoringApiService";
import CS from "./../../../commons/services/Common";
import ToggleSwitch from "../../../commons/components/input/ToggleSwitch";
import TempSlider from "../../../commons/components/input/Slider";
import MakeKey from "../../../commons/services/MakeKey";

class PowerDeviceDetail extends Component {
  constructor(props) {
    super(props);
    const { location, match } = this.props;
    const { projectId, device, deviceList } = location.state || {};
    const { id: deviceId } = match.params;

    this.state = {
      openDeviceId: null,
      projectId: projectId,
      projectName: "",
      projectAddr: "",
      deviceId: deviceId,
      device: device,
      deviceList: deviceList,
      allDeviceData: null,
      allDeviceStatus: 1, // 전체 기기 상태
      storageTankData: null,
      powerValues: {
        all: false,
      },
    };

    this.handleTargetTemp = this.handleTargetTemp.bind(this);
    this.handlePowerStatus = this.handlePowerStatus.bind(this);
    this.handleSlideTemp = this.handleSlideTemp.bind(this);
    this.updateTempSet = this.updateTempSet.bind(this);
  }

  componentDidMount() {
    // TODO: 기기 전체 상태에 대한 값 가져오기
    this.fetchAllDeviceData();
    this.fetchDeviceDetailData();
    this.autoOpenDevice();
    this.initPowerValues();
    this.fetchGetProjectData();
  }

  // 전체 전원 관리
  handleCheckBoxAll = () => {
    const { t } = this.props;
    const powerValues = { ...this.state.powerValues };

    CS.customUpdate({
      url: "/",
      param: {},
      confirmMsg: powerValues.all
        ? "해당 기기 전체 전원을 끄시겠습니까?"
        : "해당 기기 전체 전원을 켜시겠습니까?",
      successMsg: t('keykey612'), // 성공적으로 수행 되었습니다.
      cancelMsg: t('keykey613'), // 작업이 취소 되었습니다.
    }).then((res) => {
      if (res.isSuccess) {
        Object.keys(powerValues).forEach((key) => {
          powerValues[key] = powerValues.all ? false : true;
        });

        this.setState((prev) => ({
          ...prev,
          powerValues,
        }));
      }
    })
    .catch((error) => {
      console.error("Fetch Error: ", error);
    });
  };

  // 개별 전원 관리
  handleCheckBox = (id) => {
    // 등록 된 기기의 전원 상태를 변경
    const powerValues = { ...this.state.powerValues };
    powerValues[id] = !powerValues[id];
    this.setState({ powerValues });
  };

  // 디바이스 목표온도 슬라이더 핸들러 
  handleSlideTemp = (device) => (event, value) => {
    // TODO: 임시 핸들리 -> onMouseUp으로 api 호출 해야함
    // api 호출 실패할 경우도 고려해야 함
    if (!device) return;
    this.updateTempSet(device.device_no, value);
  }
  // 보일러 목표온도 핸들러
  handleTargetTemp(event, device, min, max) {
    event.preventDefault();
    event.stopPropagation(); // 이벤트 버블링 차단 (상세 정보 영역 열림 방지)
    const { t } = this.props;
    const { name } = event.target;
    if (!device || ! device.temp_set) return;

    if (device.temp_set <= min && name === "down") return;
    if (device.temp_set >= max && name === "up") return;

    try {
      // data가 없을 경우 에러 메세지 출력
      if (!name || !device) throw new Error("Invalid event or device");

      // 온도조절이 불가능한 기기인지 확인 후 에러 메세지 출력
      this.state.deviceList.map((deviceDetail) => {
        if(deviceDetail.deviceNo === device.device_no && deviceDetail.tempContr !== 1) {
          throw new Error("온도 조절이 불가능한 기기입니다.");
        }
      })

      // "up"이면 +1, "down"이면 -1
      const step = name === "up" ? 1 : name === "down" ? -1 : 0;
      if (step === 0) return;

      let newTemp = device.temp_set + step;

      // 보일러 목표 온도 컨트롤 API 호출      
      this.updateTempSet(device.device_no, newTemp);
    } catch (error) {
      Message({
        iconClass: "cancel",
        type: "warning",
        message: t('key607'), // 보일러 목표 온도 설정에 실패했습니다.
      });
      console.error("보일러 목표 온도 설정 Error", error);
    }
  }


  // 보일러 목표 온도 컨트롤 UI 변경
  updateTempSet = (deviceNo, newTemp) => {
    //TODO: API 호출
    const { boilerData } = this.state;
    // boilerData에서 deviceNo가 일치하는 데이터의 temp_set을 변경
    const updatedBoilerData = boilerData.map((data) => {
      if (String(data.device_no) === String(deviceNo)) {
        return { ...data, temp_set: newTemp };
      }
      return data;
    });
    const updateStorageTankData = this.state.storageTankData.map((data) => {
      if (String(data.device_no) === String(deviceNo)) {
        return { ...data, temp_set: newTemp };
      }
      return data;
    });
    this.setState({ boilerData: updatedBoilerData, storageTankData: updateStorageTankData });
  }

  autoOpenDevice = () => {
    const { device, deviceList } = this.state;
    const matchingDevice = deviceList?.find((dev) => dev.id === device.id);

    if (matchingDevice) {
      this.setState({ openDeviceId: matchingDevice.id });
    }
  };

  // 발전정보
  onShowDetailInfo = (deviceId) => {
    this.setState((prevState) => ({
      openDeviceId: prevState.openDeviceId === deviceId ? null : deviceId,
    }));
  };

  async fetchGetProjectData() {
    const result = await axios.get(
      `/cst/api/project/id/${this.state.projectId}`
    );
    this.setState({
      projectName: result.data.name,
      projectAddr: result.data.address,
    });
  }

  // mongoDB 데이터
  async fetchAllDeviceData() {
    try {
      const { deviceList } = this.state;
      const deviceNos = deviceList.map((dev) => dev.deviceNo); // deviceNo만 추출
      const uniqueDeviceNos = [...new Set(deviceNos)]; // 중복 제거
      // console.log("deviceNos", deviceNos);
      const siteNo = this.state.device.siteNo;
      // console.log("siteNo", siteNo);
      // const carrierData = await PS.getCarriersData(siteNo, uniqueDeviceNos);
      // console.log("carrierData", carrierData);

      const allDeviceData = await PS.getAllDeviceData(this.state.device.siteNo);
      console.log("모든 기기 데이터", allDeviceData);
      this.setState({ allDeviceData }); // 데이터를 state에 저장
    } catch (error) {
      console.error("기기 데이터 불러오기 실패", error);
    }
  }

  // 보일러 및 축열조 세부 정보 mongoDB 데이터
  async fetchDeviceDetailData() {
    try {
      const { deviceList } = this.state;

      // 보일러의 deviceNos 추출 (filteredDeviceList에서 deviceNo만 추출)
      const boilerDeviceNos = deviceList
        .filter((dev) => dev.typeId === 1 && dev.parentId !== null)
        .map((dev) => dev.deviceNo); // 보일러의 deviceNo 필드 추출

      // 축열조의 deviceNos 추출 (parentId deviceList.id와 일치하는 경우)
      const storageDeviceNos = deviceList
        .filter((storageDevice) =>
          deviceList.some(
            (boilerDevice) => boilerDevice.parentId === storageDevice.id
          )
        )
        .map((storageDevice) => storageDevice.deviceNo); // 축열조의 deviceNo 필드 추출

      // 보일러와 축열조의 deviceNos를 모두 모아서 PS.getDevicesData로 전달
      const allDeviceNos = [...boilerDeviceNos, ...storageDeviceNos]; // 두 배열을 합침
      const uniqueDeviceNos = [...new Set(allDeviceNos)]; // 중복 제거
      const carrierKeyList = deviceList.map((device) => {
        return MakeKey.carrier({
          siteNo: device.siteNo,
          rtuNo: device.rtuNo,
          deviceNo: device.deviceNo,
        })
      })
      const allDeviceData = await PS.getDevicesData(allDeviceNos);
      const allCarrierData = await PS.getCarriersData(carrierKeyList);
      console.log('캐리어 데이터 : ',allCarrierData);
      // console.log("site no : ", this.state.device.siteNo);

      // 한 번의 setState로 boilerData와 storageTankData를 동시에 업데이트
      this.setState({
        boilerData: allDeviceData.filter((data) =>
          boilerDeviceNos.includes(data.device_no)
        ), // 보일러 데이터만 필터링
        storageTankData: allDeviceData.filter((data) =>
          storageDeviceNos.includes(data.device_no)
        ), // 축열조 데이터만 필터링
      });
    } catch (error) {
      console.error("보일러 및 축열조 정보 불러오기 실패", error);
    }
  }

  //전원관리 상태값 세팅
  initPowerValues = () => {
    const { deviceList, powerValues } = this.state;

    const newPowerValues = { ...powerValues };

    const filteredDeviceList = deviceList?.filter(
      (dev) => dev.typeId === 1 && dev.parentId !== null
    );

    filteredDeviceList.forEach((device) => {
      newPowerValues[device.id] = false;
    });
    this.setState({ powerValues: newPowerValues });
  };

  // 전체기기 상태 점검중 헨들러
  handlePowerStatus = () => {
    const confirmMsg = this.state.allDeviceStatus === 4 
      ? "기기 상태 점검중을 해제하시겠습니까?" 
      : "기기 상태를 점검중으로 바꾸시겠습니까?";

    MessageBox.confirm(confirmMsg, "Confirm", {
      confirmButtonText: "예",
      cancelButtonText: "아니요",
      type: "info",
    })
      .then(() => {
        if (this.state.allDeviceStatus === 4) {
          this.setState({ allDeviceStatus: 1 }); // 기기의 상태로 변경
        } else {
          this.setState({ allDeviceStatus: 4 });
        };
        //점검중 전환 API 호출
        Message({
          type: "success",
          message: "성공적으로 수행 되었습니다.",
          iconClass: "success",
        });
      })
      .catch((error) => {
        Message({
          type: "info",
          message: error?.message ? error?.message : "작업이 취소 되었습니다.",
          iconClass: "cancel",
        });
      });
  };
  render() {
    const {
      projectName,
      projectAddr,
      openDeviceId,
      device,
      allDeviceData,
      allDeviceStatus,
      deviceList,
      boilerData,
      storageTankData,
      powerValues,
    } = this.state;
    const cumulativePower = allDeviceData?.all_cons || 0; // 누적 소비전력
    const hourlyPower = allDeviceData?.all_hourly_cons || 0; // 1시간 평균 소비전력
    // const deviceStatus = allDeviceData?.all_status || 0; // 전체 기기 상태

    // typeId가 1(보일러)이고, parentId null이 아닌 항목 필터링
    const filteredDeviceList = deviceList?.filter(
      (dev) => dev.typeId === 1 && dev.parentId !== null
    );

    return (
      <>
        <PageTitle title="시설" location="전력기기 세부정보" />
        <InfoArea>
          <InfoHead>
            {/* <h1>{device.name}</h1> */}
            <h1>{projectName}</h1>
          </InfoHead>
          <InfoContent>
            <dl>
              <dt>설치위치</dt>
              <dd>{projectAddr}</dd>
            </dl>
          </InfoContent>
          <InfoList>
            <h2>전체 전력기기 정보</h2>
            <ListWrapper columns={"1fr 1fr 1fr 1fr"} gap={"24px"}>
              <InfoListBox>
                <p>누적 소비전력</p>
                <ul>
                  <li>
                    <CountUp
                      start={0}
                      end={cumulativePower}
                      decimals={0}
                      duration={0.5}
                      separator=","
                    />
                  </li>
                  <li>kW</li>
                </ul>
              </InfoListBox>
              <InfoListBox>
                <p>1시간 평균 소비전력</p>
                <ul>
                  <li>
                    <CountUp
                      start={0}
                      end={hourlyPower}
                      decimals={2}
                      duration={1}
                      separator=","
                    />
                  </li>
                  <li>kWh</li>
                </ul>
              </InfoListBox>
              <InfoListBox>
                <p>전체 기기 상태</p>
                <ul className="control-box">
                  <li>상태 변경 가능</li>
                  <li>
                    <AllDeviceStatusButton deviceStatus={allDeviceStatus} onClick={this.handlePowerStatus}/>
                  </li>
                </ul>
              </InfoListBox>
              <InfoListBox>
                <p>+DR</p>
                <ul className="control-box">
                  <li>상태 변경 가능</li>
                  <li>
                    <AllDeviceStatusButton deviceStatus={allDeviceStatus} onClick={this.handlePowerStatus}/>
                  </li>
                </ul>
              </InfoListBox>
            </ListWrapper>
          </InfoList>
          <ControlArea>
            <ControlTitle>
              <h3>보일러</h3>
              <div className="full-power">
                <p>전체 전원 관리</p>
                <ToggleSwitch
                  isChecked={this.state.powerValues.all}
                  onChange={(e) => this.handleCheckBoxAll(e)}
                  name="power"
                  htmlFor="switchAll"
                />
              </div>
            </ControlTitle>

            {filteredDeviceList?.map((filteredDevice) => {
              const matchedBoilerData = boilerData?.find(
                (data) =>
                  String(data.device_no) === String(filteredDevice.deviceNo)
              );

              let matchedStorageTankData = [];
              if (storageTankData && deviceList) {
                // filteredDevice의 parentId 매칭되는 deviceList의 장치 (축열조)를 찾는다
                matchedStorageTankData = storageTankData.filter((tankData) => {
                  const matchedDevice = deviceList.find(
                    (device) =>
                      String(device.deviceNo).trim() ===
                        String(tankData.device_no).trim() &&
                      String(device.id) === String(filteredDevice.parentId)
                  );
                  return !!matchedDevice; // 매칭된 장치가 있으면 true 반환
                });
              }
              
              return (
                <ContentBoxWrapper key={filteredDevice.id}>
                  <ContentBox
                    onClick={() => this.onShowDetailInfo(filteredDevice.id)}
                  >
                    <p className="cont-name">{filteredDevice.name}</p>
                    <SectionWrapper>
                      {/* 축열조 축열 온도 */}
                      <section>
                        <div className="section-tit">
                          <p>축열조 축열 온도</p>
                        </div>
                        <SectionInner>
                          <dl className="current-box">
                            <dt>현재 온도</dt>
                            <dd>
                              <p>
                                {matchedStorageTankData &&
                                matchedStorageTankData.length > 0
                                  ? matchedStorageTankData[0].temp_current
                                  : "--"}{" "}
                                <span>°C</span>
                              </p>
                            </dd>
                          </dl>
                          <dl className="target-box">
                            <dt>목표 온도</dt>
                            <dd>
                              <button 
                                className="count-btn minus-btn" 
                                name="down" 
                                onClick={(event) => this.handleTargetTemp(event, matchedStorageTankData[0], 30, 80)}
                              />
                              <p>
                                {matchedStorageTankData &&
                                matchedStorageTankData.length > 0
                                  ? matchedStorageTankData[0].temp_set
                                  : "--"}{" "}
                                <span>°C</span>
                              </p>
                              <button 
                                className="count-btn plus-btn" 
                                name="up" 
                                onClick={(event) => this.handleTargetTemp(event, matchedStorageTankData[0], 30, 80)}
                              />
                            </dd>
                            <div className="slider-wrap">
                              <TempSliderControl 
                                value={matchedStorageTankData.length > 0
                                      ? matchedStorageTankData[0].temp_set : 0} 
                                max={80} 
                                min={30} 
                                updateTempSet={this.updateTempSet}
                                deviceData={matchedStorageTankData[0]}
                              />
                            </div>
                          </dl>
                        </SectionInner>
                      </section>

                      {/* 보일러 실내 온도 */}
                      <section>
                        <div className="section-tit">
                          <p>보일러 실내 온도</p>
                          <ToggleSwitch
                            isChecked={
                              this.state.powerValues[filteredDevice.id]
                            }
                            name="power"
                            htmlFor={`switch-${filteredDevice.id}`}
                            onChange={() => this.handleCheckBox(filteredDevice.id)}
                          />
                        </div>
                        <SectionInner>
                          <dl className="current-box">
                            <dt>현재 온도</dt>
                            <dd>
                              <p>
                                {matchedBoilerData?.temp_current || "--"}{" "}
                                <span>°C</span>
                              </p>
                            </dd>
                          </dl>
                          <dl className="target-box">
                            <dt>목표 온도</dt>
                            <dd>
                              <button 
                                className="count-btn minus-btn" 
                                name="down" 
                                onClick={(event) => this.handleTargetTemp(event, matchedBoilerData, 17, 30)}
                              />
                              <p>
                                {matchedBoilerData?.temp_set || "--"}{" "}
                                <span>°C</span>
                              </p>
                              <button 
                                className="count-btn plus-btn" 
                                name="up" 
                                onClick={(event) => this.handleTargetTemp(event, matchedBoilerData, 17, 30)}
                              />
                            </dd>
                            <div className="slider-wrap">
                              <TempSlider 
                                value={matchedBoilerData?.temp_set || 0} 
                                max={30} 
                                min={17} 
                                onChange={this.handleSlideTemp(matchedBoilerData)} 
                                onClick={(event) => event.stopPropagation()}
                              />
                            </div>
                          </dl>
                        </SectionInner>
                      </section>
                    </SectionWrapper>
                  </ContentBox>

                  {openDeviceId === filteredDevice.id && (
                    <ContentDetail>
                      <p className="head">{filteredDevice.name} 발전 정보</p>
                      <div className="info-list">
                        <dl>
                          <dt>실외기 Comp1 현재</dt>
                          <dd>{matchedBoilerData?.comp_rps || "--"} rps</dd>
                        </dl>
                        <dl>
                          <dt>실외기 Comp2 현재</dt>
                          <dd>{matchedBoilerData?.comp_rps2 || "--"} rps</dd>
                        </dl>
                        <dl>
                          <dt>기기 상태</dt>
                          <dd>{matchedBoilerData?.state || "--"}</dd>
                        </dl>
                        <dl>
                          <dt>현재 소비전력</dt>
                          <dd>
                            {matchedBoilerData?.pw_consumption || "--"}{" "}
                            <span>kW</span>
                          </dd>
                        </dl>
                        <dl>
                          <dt>1시간 평균 소모 전력</dt>
                          <dd>
                            {matchedBoilerData?.pw_consumption || "--"}{" "}
                            <span>kWh</span>
                          </dd>
                        </dl>
                        <dl>
                          <dt>운전모드</dt>
                          <dd>{matchedBoilerData?.mode || "--"}</dd>
                        </dl>
                      </div>
                    </ContentDetail>
                  )}
                </ContentBoxWrapper>
              );
            })}
          </ControlArea>
        </InfoArea>
      </>
    );
  }
}



// range 조절 시 빈번한 요청 방지를 위해 onMouseUp 시 api요청
class TempSliderControl extends Component {
  constructor(props) {
    super(props);
    const deviceData = this.props.deviceData;
    // console.log("prop value: ", this.props.value);
    this.state = {
      targetValue: this.props.value, // 기기 데이터에 적용
      rollbackValue: this.props.value, // api 요청 실패 시 롤백을 위한 값
      updateTempSet: this.props.updateTempSet,
      isFetching: false,
      isSuccess: false,
    };
  }

  componentDidUpdate() {
    // this.setState({ targetValue: this.props.value });
  }

  handleSlideTemp = (device) => (event, value) => {
    if (!device) return;
    this.state.updateTempSet(device.device_no, value);
    this.setState({ targetValue: value });
    // console.log("rollback: ", this.state.rollbackValue);
  };

  fetchTempSet = (device) => {
    // api 호출
    const isSuccess = false;

    if (isSuccess) {
      this.setState({ rollbackValue: this.state.targetValue });
    } else {
      this.setState({ targetValue: this.state.rollbackValue });
      const rollback = this.state.rollbackValue;
      this.state.updateTempSet(device.device_no, rollback);
    }
  }

  render() {
    return (
      <TempSlider
        value={this.props.value}
        max={this.props.max}
        min={this.props.min}
        onChange={this.handleSlideTemp(this.props.deviceData)}
        onClick={(event) => event.stopPropagation()}
        // onMouseUp={() => this.fetchTempSet(this.props.deviceData)}
      />
    );
  }
}

class AllDeviceStatusButton extends Component {
  render() {
    const { deviceStatus, onClick } = this.props;
    return (
      <DeviceStatusButton deviceStatus={deviceStatus} onClick={onClick}>
        {deviceStatus === 1
          ? "정상"
          : deviceStatus === 2
          ? "고장"
          : deviceStatus === 3
          ? "통신 오류"
          : deviceStatus === 4
          ? "점검 중"
          : "점검 중"}
      </DeviceStatusButton>
    );
  }
}

const DeviceStatusButton = styled.button`
  font-size: 14px;
  font-weight: bold;
  padding: 4px 20px;
  width: 100%;
  color: #fff;
  border-radius: 28px;
  ${({ deviceStatus }) => {
    if (deviceStatus === 1) { // 정상
      return `
        background-color: #34e466;
        border: solid 1px #63ee4c;
        box-shadow: 0 0 6px 0 rgba(69, 255, 65, 0.76);
      `;
    } else if (deviceStatus === 2) { // 고장
      return `
        background-color: #FF4242;
        border: solid 1px #FF6363;
        box-shadow: 0 0 6px 0 rgba(255, 66, 66, 0.76);
      `;
    } else if (deviceStatus === 3) { // 통신 오류
      return `
        background-color: #FFCA42;
        border: solid 1px #FFCD4E;
        box-shadow: 0 0 6px 0 rgba(252, 185, 15, 0.76);
      `;
    } else if (deviceStatus === 4) { // 점검 중
      return `
        background-color: #7E7E7E;
        border: solid 1px #9B9B9B;
        box-shadow: 0 0 6px 0 rgba(126, 126, 126, 0.76);
      `;
    } else {
      return `
        background-color: #7E7E7E;
        border: solid 1px #9B9B9B;
        box-shadow: 0 0 6px 0 rgba(126, 126, 126, 0.76);
      `;
    }
  }}
`;
const ControlArea = styled.div`
  padding-bottom: 180px;
`;
const ControlTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: column;
  align-items: center;
  padding: 30px 0 15px;
  .full-power {
    text-align: right;
    p {
      display: inline-block;
      vertical-align: middle;
      padding: 0 12px 0 0;
    }
  }
`;
const ContentBoxWrapper = styled.div`
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
`;
const ContentBox = styled.div`
  border: 1px solid #e5e6e8;
  border-radius: 12px;
  cursor: pointer;
  &:hover {
    box-shadow: 0 0 10px rgba(11, 148, 63, 0.5);
  }
  .cont-name {
    font-size: 16px;
    font-weight: bold;
    color: #191919;
    padding: 9px 20px;
    border-radius: 12px 12px 0 0;
    background-color: #f2f3f5;
    border-bottom: 1px solid #e5e6e8;
  }
`;
const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  section {
    padding: 20px;
    &:first-child {
      border-right: 1px solid #e5e6e8;
    }
  }
  .section-tit {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-flow: column;
    align-items: center;
    padding-bottom: 20px;
    p {
      height: 28px;
      line-height: 28px;
      font-size: 15px;
      font-weight: 500;
      color: #191919;
    }
  }
`;
const SectionInner = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  align-items: center;
  gap: 12px;
  dl {
    border-radius: 10px;
    padding: 15px;
  }
  .current-box {
    background-color: #E8F4E7;
  }
  .target-box {
    background-color: #f2f3f5;
  }
  .slider-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    items-align: center;
  }
  dt {
    font-size: 14px;
    font-weight: 500;
    color: #797979;
    text-align: center;
    padding-bottom: 10px;
  }
  dd {
    text-align: center;
    p {
      display: inline-block;
      vertical-align: middle;
      font-size: 30px;
      color: #191919;
      font-weight: 600;
    }
    .count-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 29px;
      height: 29px;
      border-radius: 50%;
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        background-repeat: no-repeat;
        width: 15px;
        height: 15px;
        background-size: contain;
      }
    }
    .minus-btn {
      margin-right: 120px;
      border: 1px solid #b7b7b7;
      background-color: #fff;
      &::after {
        background-image: url("/images/ctors/icon/count-btn-icon.png");
        transform: translate(-50%, -50%) rotate(180deg);
      }
      &:active {
        background-color: #4A4A4A;
      }
      &:active::after {
        background-image: url("/images/ctors/icon/count-btn-hover.png");
        transform: translate(-50%, -50%) rotate(180deg);
      }
    }
    .plus-btn {
      margin-left: 120px;
      border: 1px solid #b7b7b7;
      background-color: #fff;
      &::after {
        background-image: url("/images/ctors/icon/count-btn-icon.png");
        transform: translate(-50%, -50%);
      }
      &:active {
        background-color: #4A4A4A;
      }
      &:active::after {
        background-image: url("/images/ctors/icon/count-btn-hover.png");
        transform: translate(-50%, -50%);
      }
    }
  }
`;
const ContentDetail = styled.div`
  background-color: #f2f3f5;
  border-radius: 12px;
  padding: 20px;
  margin-top: 12px;
  .head {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 12px;
    border-bottom: 1px solid #b5b5b5;
  }
  .info-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    dt,
    dd {
      display: inline-block;
      vertical-align: middle;
      padding: 10px 0;
      font-size: 14px;
      font-weight: 500;
      color: #191919;
    }
    dt {
      width: 140px;
    }
    dd {
      padding-left: 30px;
    }
    span {
      display: inline-block;
      vertical-align: top;
    }
  }
`;
export default withRouter(PowerDeviceDetail);
